import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
const QuestionMarkCircleIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8ZM5.496 6.033C5.46377 6.03344 5.43178 6.02729 5.402 6.01494C5.37222 6.00259 5.34528 5.9843 5.32281 5.96118C5.30035 5.93806 5.28284 5.9106 5.27135 5.88048C5.25986 5.85036 5.25464 5.81821 5.256 5.786C5.35 4.091 6.737 3.5 8.005 3.5C9.401 3.5 10.677 4.23 10.677 5.74C10.677 6.82 10.042 7.334 9.433 7.797C8.696 8.356 8.423 8.565 8.423 9.283V9.388C8.423 9.4543 8.39666 9.51789 8.34978 9.56478C8.30289 9.61166 8.2393 9.638 8.173 9.638H7.363C7.29738 9.63801 7.23439 9.61222 7.18762 9.5662C7.14085 9.52017 7.11405 9.45761 7.113 9.392L7.109 9.175C7.071 8.248 7.604 7.677 8.277 7.188C8.867 6.744 9.242 6.452 9.242 5.817C9.242 4.992 8.614 4.649 7.928 4.649C7.125 4.649 6.675 5.127 6.586 5.783C6.568 5.92 6.458 6.033 6.32 6.033H5.495H5.496ZM7.821 12.476C7.237 12.476 6.812 12.082 6.812 11.549C6.812 10.997 7.237 10.609 7.822 10.609C8.431 10.609 8.85 10.997 8.85 11.549C8.85 12.082 8.43 12.476 7.821 12.476Z",
    fill: color
  }));
};
export default QuestionMarkCircleIcon;